import { inject, Injectable, Injector } from '@angular/core';
import { BaseService } from '../../base/base.service';
import { IPrivilegeModel } from '../../model/user/privilege.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PrivilegeService extends BaseService<IPrivilegeModel> {
    constructor() {
        super(inject(Injector), 'privilege');
    }

    public findAllPrivileges(): Observable<IPrivilegeModel[]> {
        return this.httpClient.get<IPrivilegeModel[]>(
            `${this.environment.APP.VC_USER_BASE_URL}/${this.serviceBaseUrl}`
        );
    }

    public searchPrivileges(): Observable<IPrivilegeModel[]> {
        return this.findAllPrivileges();
    }

    public updatePrivilege(model: IPrivilegeModel): Observable<IPrivilegeModel> {
        return this.httpClient.post<IPrivilegeModel>(
            `${this.environment.APP.VC_USER_BASE_URL}/${this.serviceBaseUrl}`,
            model
        );
    }

    public getPrivilegeByName(name: string): Observable<IPrivilegeModel> {
        return this.httpClient.get<IPrivilegeModel>(
            `${this.environment.APP.VC_USER_BASE_URL}/${this.serviceBaseUrl}/${name}`
        );
    }

    public deletePrivilege(name: string): Observable<void> {
        return this.httpClient.delete<void>(`${this.environment.APP.VC_USER_BASE_URL}/${this.serviceBaseUrl}/${name}`);
    }
}
